<template>
  <div :class="{'p-6': $mq != 'mobile', 'p-4': $mq == 'mobile'}">
    <p
      class="uppercase text-lg font-medium text-brand text-center my-4 sm:my-6"
      v-if="$mq == 'mobile'"
    >Enter your Personal Details</p>

    <div :class="{'p-6 border': $mq != 'mobile'}">
      <div class="my-6 relative">
        <p
          class="uppercase text-lg font-light text-center my-6"
          v-if="$mq != 'mobile'"
        >Enter your Personal Details</p>
        <div
          class="text-center sm:text-right sm:absolute sm:right-0 sm:top-0 text-sm font-light text-grey"
        >
          <span class="text-brand">*</span> Required fields
        </div>
      </div>

      <form class="py-4 mt-4 text-center sm:text-left" @submit.prevent="validateAndNext">
        <div class="flex flex-wrap">
          <div class="w-full sm:w-1/2 sm:pr-8">
            <label class="font-medium">
              <span class="text-brand">*</span> First Name
            </label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              v-model="form.user.first_name"
              v-validate="'required'"
              name="first_name"
              tabindex="1"
              :class="{'border-red':errors.has('first_name')}"
            >
            <div
              v-show="errors.has('first_name')"
              class="text-red text-sm mt-2"
            >{{ errors.first('first_name') }}</div>
          </div>
          <div class="w-full sm:w-1/2 mt-4 sm:mt-0">
            <label class="font-medium">
              <span class="text-brand">*</span> Last Name
            </label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              v-model="form.user.last_name"
              v-validate="'required'"
              name="last_name"
              tabindex="2"
              :class="{'border-red':errors.has('last_name')}"
            >
            <div
              v-show="errors.has('last_name')"
              class="text-red text-sm mt-2"
            >{{ errors.first('last_name') }}</div>
          </div>
        </div>
        <div class="flex flex-wrap sm:mt-8">
          <div class="w-full sm:w-1/2 mt-4 sm:mt-0 sm:pr-8">
            <label class="font-medium">
              <span class="text-brand">*</span> Email
            </label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              v-model="form.user.email"
              v-validate="'required|email'"
              name="email"
              tabindex="3"
              :class="{'border-red':errors.has('email')}"
            >
            <div
              v-show="errors.has('email')"
              class="text-red text-sm mt-2"
            >{{ errors.first('email') }}</div>
            <div
              v-show="!is_unique"
              class="text-red text-sm mt-2"
            >Email Address must be unique and not yet registered</div>
          </div>
          <div class="w-full sm:w-1/2 mt-4 sm:mt-0">
            <label class="font-medium">
              <span class="text-brand">*</span> Mobile
            </label>
            <input
              type="text"
              class="w-full border py-2 px-3 mt-2 rounded"
              v-model="form.user.mobile_number"
              v-validate="'required|numeric'"
              name="mobile_number"
              tabindex="4"
              :class="{'border-red':errors.has('mobile_number')}"
            >
            <div
              v-show="errors.has('mobile_number')"
              class="text-red text-sm mt-2"
            >{{ errors.first('mobile_number') }}</div>
          </div>
        </div>
        <div class="flex flex-wrap sm:mt-8">
          <div class="w-full sm:w-1/2 mt-4 sm:mt-0 sm:pr-8">
            <label class="font-medium">
              <span class="text-brand">*</span> Create a Password
            </label>
            <input
              class="appearance-none border rounded w-full p-3 text-grey-darker"
              id="password"
              type="password"
              name="password"
              v-model="form.user.password"
              data-vv-validate-on="blur"
              tabindex="5"
              v-validate="'required|min:8'"
              :class="{'border-red':errors.has('password')}"
            >
            <div
              v-show="errors.has('password')"
              class="text-red text-sm mt-2"
            >{{ errors.first('password') }}</div>
            <div
              v-show="invalid_password"
              class="text-red text-sm mt-2"
              v-for="errors, type in password_errors"
            >{{join(errors)}}</div>
          </div>
          <div class="w-full sm:w-1/2 mt-4 sm:mt-0">
            <label class="font-medium">
              <span class="text-brand">*</span> Confirm Password
            </label>
            <input
              class="appearance-none border rounded w-full p-3 text-grey-darker"
              id="confirm_password"
              type="password"
              name="confirm_password"
              v-model="form.user.password_confirmation"
              data-vv-validate-on="blur"
              tabindex="6"
              v-validate="'required|confirmed:password'"
              :class="{'border-red':errors.has('confirm_password')}"
            >
            <div
              v-show="errors.has('confirm_password')"
              class="text-red text-sm mt-2"
            >{{ errors.first('confirm_password') }}</div>
          </div>
        </div>
        <button type="submit" class="invisible"></button>
      </form>
    </div>

    <div class="text-center mt-4" v-if="detailReview">
      <button
        class="border bg-grey-lighter p-4 w-32 text-black border-grey rounded font-medium"
        type="submit"
        @click="backToFinish()"
      >Back</button>
    </div>

    <div class="flex flex-row justify-between mt-4" v-else>
      <button
        class="border bg-grey-lighter p-4 w-32 text-black border-grey rounded font-medium"
        type="button"
        @click="back()"
      >Back</button>
      <button
        class="border bg-brand p-4 w-32 text-white rounded font-medium"
        type="submit"
        @click="validateAndNext()"
      >Continue</button>
    </div>

    <sweet-modal overlay-theme="dark" ref="email_not_unique" icon="warning">
      <div class="flex flex-col">
        <h2 class="w-full text-orange">Invalid Email</h2>
        <p class="m-2">Your email must be unique and not yet registered.</p>
        <p class="m-2">
          Please
          <button
            class="p-2 py-1 text-grey rounded border-2 border-grey hover:bg-grey hover:text-white"
            @click="redirectToLogin()"
          >Log In</button> or
          <button
            class="p-2 py-1 text-brand rounded border-2 border-brand hover:bg-brand hover:text-white"
            @click="$refs.email_not_unique.close()"
          >Try Again</button>
        </p>
      </div>
    </sweet-modal>

    <sweet-modal overlay-theme="dark" icon="error" ref="password_errors">
      <div class="flex flex-col">
        <h2 class="w-full text-orange">Invalid Password</h2>
        <div class="m-2">
          <p
            class="text-red text-sm"
            v-if="password_errors != ''"
            v-for="errors, type in password_errors"
          >
            <i class="fa fa-exclamation"></i>
            <span>{{join(errors)}}</span>
          </p>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
export default {
  props: ["value", "step", "detail-review", "steps"],

  data() {
    return {
      form: _.cloneDeep(this.value),
      is_unique: true,
      invalid_password: false,

      password_errors: []
    };
  },

  mounted() {
    let next = _.toNumber(this.step) + 1;
    this.next = next;

    let prev = _.toNumber(this.step) - 1;
    this.prev = prev;
  },

  methods: {
    join(err) {
      return _.join(err);
    },
    validateAndNext() {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios
            .all([this.isUniqueEmail(), this.validatePassword()])
            .then(
              axios.spread((email, password) => {
                if (email.status == 200) {
                  this.checking_email = false;
                  this.invalid_password = false;
                  let data = email.data;

                  if (data.success) {
                    if (!data.email_exists) {
                      this.is_unique = true;
                      this.$emit("go-to", {
                        next_step: this.next
                      });
                    } else {
                      this.$refs.email_not_unique.open();
                      this.is_unique = false;
                    }
                  } else {
                    return false;
                  }
                }
              })
            )
            .catch(error => {
              this.checking_email = false;
              this.password_errors = [];
              let data = error.response.data;
              if (data != "") {
                if (!_.isNil(data.errors) && _.isObject(data.errors)) {
                  let form_errors = this.fixFormErrors(data.errors);
                  this.password_errors = form_errors;
                  this.$refs.password_errors.open();
                  this.invalid_password = true;
                }
              }
            });
        }
      });
    },
    fixFormErrors(errors) {
      let errs = [errors];
      return _.reduce(
        errs,
        function(object, value) {
          return _.assign(object, value);
        },
        {}
      );
    },
    isUniqueEmail() {
      this.checking_email = true;
      return axios.post("/api/register/check-email", {
        email_address: this.form.user.email
      });
    },
    validatePassword() {
      this.invalid_password = true;
      return axios.post("/api/register/test-password", {
        password: this.form.user.password
      });
    },
    back() {
      this.$emit("go-to", {
        next_step: this.prev,
        next_sub_step: 2
      });
    },
    backToFinish() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("go-to", {
            next_step: _.findLastKey(this.steps)
          });
        }
      });
    },
    redirectToLogin() {
      window.location.href = "/auth-login";
    }
  },

  watch: {
    form: {
      deep: true,
      handler: function() {
        this.$emit("input", this.form);
      }
    }
  }
};
</script>

<style>
</style>
